/**
 * GET /rest/me - the signed-in user, as the Task API sees them.
 *
 * Registered on its own rather than paired with the Web API's /startup, which is the nearest thing
 * that API has to it. The two do not compare: /startup wraps the user in a session payload
 * (`loggedInUser`, `userConfiguration`, `sessionHash`) and shares no top-level field with `User`, so
 * there is nothing for compare.js to pair the two single-item responses on. Run them side by side as
 * two operations and read the panels instead.
 */
export const currentUser = {
    id: "current-user",
    label: "Current user",
    summary: "Who the Task API thinks is calling: id, name, email, locale and time zone.",
    params: [],
    sides: {
        task: {
            method: "GET",
            path: "/me",
            operationId: "getCurrentUser",
            scope: "session:read",
            // the spec marks Accept required: it selects the response content version
            accept: "application/vnd.approval-platform-v1+json",
            extract: body => [body],
            shape: "User { userId, connectUserId, firstName, lastName, emailAddress, languageCode, countryCode, timeZone }",
        },
    },
};
